import styled from "styled-components";

import "../../GlobalStyles/Font.css";

export const Logo = styled.h1`
  font-size: 20px;
  font-family: "Exo2 Light";
  line-height: 1.2;
  color: #000000;

  @media (min-width: 428px) {
    font-size: 24px;
    line-height: 1.2;
  }

  @media (min-width: 1024px) {
    font-size: 32px;
    line-height: 1.18;
  }

  @media (min-width: 1440px) {
    font-size: 36px;
    line-height: 1.19;
  }
`;

export const LogoColor = styled.span`
  color: #1ac63f;
`;
